export default {
  data () {
    return {
      errors: [],
      states: []
    }
  },
  methods: {
    handleResponseError (error) {
      console.log('error', error)
      console.log('error.response.status', error.response.status)
      if (error.response.status === 401) {
        this.$router.push({name: 'login'})
      }
      if (error.response.status === 404) {
        this.openAlert(error.response.data, 'Aviso', 'danger')
      }
      if (error.response.status === 400) {
        if (error.response) {
          this.errors = error.response.data.data
          if (this.errors.length > 0) {
            this.errors.forEach((erro) => {
              this.openAlert(erro.msg, 'Erro', 'danger')
            })
          }
        }
      }
    },
    openAlert (texto, titulo, variant = null) {
      this.$bvToast.toast(texto, {
        title: titulo || 'Mensagem',
        variant: variant || 'default',
        solid: false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/form.js